import { bunja } from 'bunja';
import { atom } from 'jotai';

import { CopyTradePerformancePeriod } from '@flipster/apis/v1/copy-trade/types';

import { copyTradingBunja } from '../../../shared/copy-trading/state';
import { CopyTradeSortKey, sortPortfolios } from './utils';

export const meetMasterTraderBunja = bunja(() => {
  const { portfoliosAtom } = bunja.use(copyTradingBunja);

  const searchQueryAtom = atom('');
  const sortKeyAtom = atom<CopyTradeSortKey>('roi');
  const periodAtom = atom<CopyTradePerformancePeriod>('30d');

  /** Card grid: sort + period only. Search does not filter cards. */
  const sortedPortfoliosAtom = atom((get) => {
    const portfolios = get(portfoliosAtom);
    const sortKey = get(sortKeyAtom);
    const period = get(periodAtom);

    return sortPortfolios(portfolios, sortKey, period);
  });

  return {
    portfoliosAtom,
    searchQueryAtom,
    sortKeyAtom,
    periodAtom,
    sortedPortfoliosAtom,
  };
});
meetMasterTraderBunja.debugLabel = 'meetMasterTraderBunja';
